import React from 'react';
import { useTranslation } from 'react-i18next';
import { Main, ContentSection, SectionHeading, Heading } from '@vwfs-bronson/bronson-react';

const LinkExpiredPage: React.FunctionComponent = () => {
  const { t } = useTranslation('error-pages');

  return (
    <Main>
      <ContentSection pageWrap>
        <Heading level={3}>410</Heading>
        <SectionHeading level={1} subtitle={t('link-expired-subtitle')}>
          {t('link-expired-title')}
        </SectionHeading>
        {/* <Layout className="u-mt-large">
          <Layout.Item default="3/12" m="1/3" s="1/1">
            <Link to={RouterHelpers.getEntryPointPath()}>
              <Button full>{t('shared:back-button')}</Button>
            </Link>
          </Layout.Item>
        </Layout> */}
      </ContentSection>
    </Main>
  );
};

export default LinkExpiredPage;
